import useSWR from 'swr';
import graphqlApi from '../api/graphqlApi';
import useProductsPrice from '../products/useProductsPrice';
import { createShopifyProductQuery } from './queries/shopifyProductByHandle';
import { convertProductsIds } from '../../utils/utils';
import { Product } from '../../models/Product';

const useShopifyProductSWR = (handle) => {
    const fetchAllMenuItem = (query): Promise<Product> => {
        return graphqlApi
            .post(query)
            .then((res) => {
                if (res && res.productByHandle) {
                    return useProductsPrice(
                        convertProductsIds([res.productByHandle])
                    ).then((elem) => {
                        return {
                            ...res.productByHandle,
                            customPrices: elem.priceList,
                        };
                    });
                } else {
                    return null;
                }
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate } = useSWR(
        createShopifyProductQuery(handle),
        fetchAllMenuItem,
        {
            dedupingInterval: 600000, // 10min
            errorRetryCount: 3,
        }
    );

    return {
        product: data ? data : null,
        isLoading: isLoading,
        isError: error,
        forceRefresh: mutate,
    };
};

export default useShopifyProductSWR;
